import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatEmailForDisplay(email: string): { name: string; company: string } {
  // Extract local part (before @) for name
  const localPart = email.split('@')[0];
  
  // Extract domain for company
  const domain = email.split('@')[1]?.split('.')[0] || '';
  
  // Format name: convert dots/underscores to spaces and capitalize
  const name = localPart
    .replace(/[._]/g, ' ')
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
    
  // Format company: capitalize domain
  const company = domain.charAt(0).toUpperCase() + domain.slice(1);
  
  return { name, company };
}

// Recent registrations animation data
export const RECENT_REGISTRATIONS = [
  { name: "Sarah", company: "TechCorp" },
  { name: "Michael", company: "InnovateHub" },
  { name: "Emily", company: "FutureWorks" },
  { name: "David", company: "DataFlow" },
  { name: "Jessica", company: "CloudSys" },
];
